module.exports = __webpack_public_path__ + "img/bg-home-persona-3.597a0e0.png";